export const PERSONAL_DETAIL_BY_CLIENT_LOADING = 'PERSONAL_DETAIL_BY_CLIENT_LOADING'
export const PERSONAL_DETAIL_BY_CLIENT_SUCCESS = 'PERSONAL_DETAIL_BY_CLIENT_SUCCESS'
export const PERSONAL_DETAIL_BY_CLIENT_FAILED = 'PERSONAL_DETAIL_BY_CLIENT_FAILED'